export default "__VITE_ASSET__B3g1Yucn__"